import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, ClipboardListIcon, CalendarDaysIcon, WindIcon, FileTextIcon, InfinityIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const INCLUDES = [{
  icon: BookOpenIcon,
  title: '9 capítulos',
  text: 'Organizados en 3 partes, cortos y con un ejercicio práctico en cada uno.'
}, {
  icon: ClipboardListIcon,
  title: 'Checklist inicial',
  text: 'Para identificar tus señales de autoexigencia más frecuentes en una semana.'
}, {
  icon: CalendarDaysIcon,
  title: 'Diario de 7 días',
  text: '3 preguntas por día para mapear de dónde viene tu autoexigencia.'
}, {
  icon: WindIcon,
  title: 'Guion de pausa',
  text: 'Una pausa consciente de 5 minutos para usar cuando la necesites.'
}, {
  icon: FileTextIcon,
  title: 'Formato PDF',
  text: 'Leelo en el celu, la tablet o la compu cuando quieras.'
}, {
  icon: InfinityIcon,
  title: 'Acceso para siempre',
  text: 'Pago único, sin suscripciones. Es tuyo desde el momento de la compra.'
}];
export function Includes() {
  return <section className="w-full bg-sage-band py-20 md:py-28" data-id="element-85" data-mp="3pnei72eyykre">
      <div className="mx-auto max-w-5xl px-6" data-id="element-86" data-mp="3lmayg4tsw4kw">
        <SectionHeading eyebrow="Qué incluye" title="Todo lo que recibís" data-id="element-87" data-mp="3ll004kj4jp16" />
        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-88" data-mp="3gpko7y4og37e">
          {INCLUDES.map((item, i) => {
          const Icon = item.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.5,
            ease: 'easeOut',
            delay: i % 3 * 0.08
          }} className="bg-cream p-8" data-id="element-89" data-mp="d8lyp8igvmlj" data-mpi={i}>
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-sage/15 text-sage" data-id="element-90" data-mp="2ufue6nrd1imi">
                  <Icon size={22} strokeWidth={1.5} data-id="element-91" data-mp="2gerqy7omq2a0" />
                </span>
                <h3 className="mt-6 font-serif text-2xl text-ink" data-id="element-92" data-mp="2leebl26seksu">
                  {item.title}
                </h3>
                <p className="mt-3 font-sans text-[15px] leading-relaxed text-ink-soft" data-id="element-93" data-mp="26oynxv2jyvhd">
                  {item.text}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}